import { createContext } from "react";

export const SemContext = createContext();